export default "__VITE_ASSET__9656ffb1__"